export const gradToPersian = {
  class_1: 'درجه یک',
  class_2: 'درجه دو',
  class_3: 'درجه سه',
  class_4: 'درجه چهار',
};
